module.exports = __webpack_public_path__ + "static/media/dublin-4.10fd06b4.jpg";